"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.F_Instant_Elapsed = exports.UnitElapsed = void 0;
var polyfill_1 = require("@js-temporal/polyfill");
var F_Instant_1 = __importDefault(require("./F_Instant"));
var util_1 = require("./util");
var UnitElapsed = /** @class */ (function () {
    /** @hidden */
    function UnitElapsed(instant, unit, timezone) {
        if (timezone === void 0) { timezone = null; }
        this.instant = instant;
        this.unit = unit;
        this.timezone = timezone;
        this.after = this.after.bind(this);
        this.before = this.before.bind(this);
        this.toIntTowardsZero = this.toIntTowardsZero.bind(this);
        this.difference = this.difference.bind(this);
        this.getZonedDateTime = this.getZonedDateTime.bind(this);
        this.inTimeZone = this.inTimeZone.bind(this);
    }
    /** @hidden */
    UnitElapsed.prototype.toIntTowardsZero = function (total) {
        var ceilFloor = total < 0 ? Math.ceil(total) : Math.floor(total);
        // -0 is a thing in javascript, and is weird.
        return Object.is(ceilFloor, -0) ? 0 : ceilFloor;
    };
    /** @hidden */
    UnitElapsed.prototype.getZonedDateTime = function (instant, timeZone) {
        var _a;
        if (instant === void 0) { instant = this.instant; }
        if (timeZone === void 0) { timeZone = (_a = this.timezone) !== null && _a !== void 0 ? _a : polyfill_1.Temporal.Now.timeZoneId(); }
        return instant.toZonedDateTime({
            timeZone: timeZone,
            calendar: new polyfill_1.Temporal.Calendar('iso8601'),
        });
    };
    /** @hidden */
    UnitElapsed.prototype.difference = function (otherIso, dir, timeZone) {
        if (!otherIso) {
            throw new Error('not other date');
        }
        switch (this.unit) {
            case 'months':
            case 'years':
                // For these, we need to compare zonedDateTimes
                return this.toIntTowardsZero(this.getZonedDateTime(this.instant, timeZone).since(this.getZonedDateTime(polyfill_1.Temporal.Instant.from(otherIso), timeZone), { largestUnit: this.unit })[this.unit] * dir);
            default:
                return this.toIntTowardsZero(this.instant.since(otherIso).total({
                    unit: this.unit,
                    relativeTo: this.getZonedDateTime(),
                }) * dir);
        }
    };
    UnitElapsed.prototype.inTimeZone = function (timeZone) {
        return new UnitElapsed(this.instant, this.unit, timeZone);
    };
    UnitElapsed.prototype.after = function (arg1, arg2, arg3) {
        var _a, _b;
        if (arg1 instanceof F_Instant_1.default) {
            return this.difference(arg1.toIso(), 1);
        }
        var _c = (_a = (0, util_1._constructInstant)(arg1, arg2, arg3)) !== null && _a !== void 0 ? _a : [null], instant = _c[0], tz = _c[1];
        return this.difference(instant === null || instant === void 0 ? void 0 : instant.toIso(), 1, (_b = this.timezone) !== null && _b !== void 0 ? _b : tz);
    };
    UnitElapsed.prototype.before = function (arg1, arg2, arg3) {
        var _a, _b;
        if (arg1 instanceof F_Instant_1.default) {
            return this.difference(arg1.toIso(), -1);
        }
        var _c = (_a = (0, util_1._constructInstant)(arg1, arg2, arg3)) !== null && _a !== void 0 ? _a : [null], instant = _c[0], tz = _c[1];
        return this.difference(instant === null || instant === void 0 ? void 0 : instant.toIso(), -1, (_b = this.timezone) !== null && _b !== void 0 ? _b : tz);
    };
    return UnitElapsed;
}());
exports.UnitElapsed = UnitElapsed;
var F_Instant_Elapsed = /** @class */ (function () {
    /** @hidden */
    function F_Instant_Elapsed(instant) {
        this.instant = instant;
        this.minutes = new UnitElapsed(this.instant, 'minutes');
        this.hours = new UnitElapsed(this.instant, 'hours');
        this.days = new UnitElapsed(this.instant, 'days');
        this.weeks = new UnitElapsed(this.instant, 'weeks');
        this.months = new UnitElapsed(this.instant, 'months');
        this.years = new UnitElapsed(this.instant, 'years');
    }
    return F_Instant_Elapsed;
}());
exports.F_Instant_Elapsed = F_Instant_Elapsed;
//# sourceMappingURL=F_Instant_Elapsed.js.map